import { DialogContentText, useTheme, useMediaQuery } from '@mui/material';
import { memo } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { PmiDialog } from 'shell/components/shared/dialog';
import { PmiDialogContent } from 'shell/components/shared/dialog/content';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';

interface DeleteSuccessModalComponentProps {
  open: boolean;
  onClose: (open?: boolean) => void;
  onOk: (open?: boolean) => void;
  title: string;
  message: string;
}

const DeleteSuccessModalComponent = ({
  open,
  title,
  message,
  onClose,
  onOk,
}: DeleteSuccessModalComponentProps): React.ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return open ? (
    <PmiDialog
      open={open}
      fullScreen={fullScreen}
      onClose={() => onClose(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <PmiDialogTitle id="alert-dialog-title" backgroundColor="cdmBrandSecondary" color="white">
        {title}
      </PmiDialogTitle>
      <PmiDialogContent>
        <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
      </PmiDialogContent>
      <div className="pmi-d-flex pmi-justify-content-end pmi-pb-3 pmi-px-3">
        <div className="pmi-w-25">
          <PmiButton fullWidth onClick={() => onOk(false)} color="primary" variant="contained">
            Ho capito
          </PmiButton>
        </div>
      </div>
    </PmiDialog>
  ) : (
    <></>
  );
};

DeleteSuccessModalComponent.displayName = 'Delete Success Modal component';

const DeleteSuccessModal = memo(DeleteSuccessModalComponent);

export default DeleteSuccessModal as typeof DeleteSuccessModalComponent;
